<template>
  <div class="customerAcountDetail">
    <div class="content">
      <div class="back" @click="goBack">
        <md-icon name="arrow-left" size="xs" style="font-size: 0.24rem;"></md-icon>
        <span>返回</span>
      </div>
      <div class="tl">
        <div class="left">
          <span>{{sum.s_name}}</span>
          <span>{{sum.supplier_sn | addZero}}，</span>
          <span>
            商品金额共
            <span>{{sum.receivables*1}}</span>元
          </span>
          <span>，{{sum.order_count}}单</span>
          <span>，{{sum.count}}个商品</span>
        </div>
        <div class="time">
          <Calendar v-model="data_picker" @change="changeTime"></Calendar>
        </div>
      </div>
      <div class="listBox" v-if="list.length>0">
        <div class="title">
          <span>序号</span>
          <span>商品名</span>
          <span>包装</span>
          <span>单数</span>
          <span>数量|重量</span>
          <span>均价</span>
          <span>商品金额</span>
          <span></span>
        </div>
        <div class="detailBox">
          <md-scroll-view
            ref="scrollView"
            :auto-reflow="false"
            :bouncing="true"
            :scrolling-x="false"
            @end-reached="$_onEndReached"
          >
            <div
              v-for="(item,index) in list"
              :key="index"
              class="list"
              @click="lookGoodsDetail(item.batch)"
            >
              <span>{{index+1}}</span>
              <span>{{item.name}}</span>
              <span>
                <span v-if="item.bale==1" style="background:#DAEFFB;color:#1D78C5">定装</span>
                <span v-if="item.bale==2" style="background:#FBEDDA;color:#BF8535">非定装</span>
                <span v-if="item.bale==3" style="background:#DAFBDB;color:#4B9C64">散装</span>
              </span>
              <span>{{item.count}}单</span>
              <span>
                <span>
                  <span v-if="item.bale!=3">{{item.num*1}}{{unit_list[item.num_unit-1].name}} |</span>
                  {{item.weight*1}}公斤
                </span>
              </span>
              <span>
                <span
                  v-if="item.bale!=3"
                >{{item.price_unit*1}}元/{{unit_list[item.num_unit-1].name}}|</span>
                {{item.price_weight*1}}元/公斤
              </span>
              <span>{{item.goods_total_price*1}}元</span>
              <span>
                <md-icon name="arrow-right" size="sm"></md-icon>
              </span>
            </div>
            <md-scroll-view-more
              :finished-text="list.length>0?'全部已加载':'暂无数据'"
              slot="more"
              :is-finished="isFinished"
            ></md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>
      <div v-if="list.length==0" style="text-align:center;color:#999">暂无数据~</div>
    </div>
  </div>
</template>
<script>
import { Batch_Acount_Detail } from "@/api/work/acount/salesAcount";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "customerAcountDetail",
  components: {
    Calendar,
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      dataQuery: {
        goods_batch_id: "",
        s: "",
        e: "",
        orderby: "",
        desc: "",
        page: 1,
        pagesize: 55,
      },
      data_picker: [],
      isFinished: false,
      sum: {
        s_name: "",
        supplier_sn: "",
        count: "",
        order_count: "",
        receivables: "",
        discount: "",
      },
      list: [],
    };
  },
  created() {
    this.dataQuery.goods_batch_id = this.$route.query.goods_batch_id;
    this.sum.s_name = this.$route.query.supplier_name;
    if (this.$route.query.s) {
      this.dataQuery.s = this.$route.query.s;
      this.dataQuery.e = this.$route.query.e;
      this.data_picker[0] = new Date(this.$route.query.s).getTime() / 1000;
      this.data_picker[1] = new Date(this.$route.query.e).getTime() / 1000;
    }
    this.getList();
  },
  mounted() {},
  methods: {
    //返回上一级
    goBack() {
      this.$router.go(-1);
    },
    getList() {
      if (this.dataQuery.page == 1) {
        this.list = [];
      }
      Batch_Acount_Detail(this.dataQuery).then((res) => {
        if (res.code == 200) {
          this.sum.supplier_sn = res.data.supplier_sn || 0;
          this.sum.count = res.data.count || 0;
          this.sum.order_count = res.data.order_count || 0;
          this.sum.receivables = res.data.receivables || 0;
          this.sum.discount = res.data.discount || 0;
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.dataQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.dataQuery.s = timestampToDate(this.data_picker[0]);
        this.dataQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.dataQuery.s = "";
        this.dataQuery.e = "";
      }
      this.dataQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //查看详情
    lookGoodsDetail(batch) {
      this.$router.push({
        path: "/data/batchAcountDetail/batchAcountGoodsDetail",
        query: { batch,s:this.dataQuery.s,e:this.dataQuery.e },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.customerAcountDetail {
  padding: 0.1rem;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 0;
  .content {
    padding: 0.2rem;
    background: #fff;
    border-radius: 0.1rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: 100%;
    .back {
      margin-bottom: 0.26rem;
      color: #31b158;
      font-weight: bold;
      font-size: 0.24rem;
      height: 0.32rem;
    }
    .tl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.32rem;
      margin: 0 0.22rem;
      .left {
        display: flex;
        align-items: center;
        > span {
          font-size: 0.22rem;
          color: #404040;
        }
        > span:nth-of-type(1) {
          max-width: 2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(3) {
          > span {
            color: #31b158;
          }
        }

        .discount {
          font-size: 0.2rem;
          color: #999999;
          font-weight: normal;
          span {
            color: #999999;
            font-size: 0.2rem;
            font-weight: normal;
          }
        }
      }
    }
    .listBox {
      margin: 0 0.22rem;
      margin-top: 0.12rem;
      height: calc(100% - 0.32rem - 0.32rem - 0.26rem);

      .title {
        height: 0.68rem;
        border-top: 0.01rem solid #e5e5e5;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 0.22rem;
          color: #555;
          font-weight: bold;
          text-align: center;
          text-overflow: clip;
          white-space: nowrap;
          overflow: hidden;
        }
        span:nth-of-type(1) {
          width: 0.6rem;
        }
        span:nth-of-type(2) {
          width: 1.6rem;
        }
        span:nth-of-type(3) {
          width: 0.8rem;
        }
        span:nth-of-type(4) {
          width: 1rem;
        }
        span:nth-of-type(5) {
          width: 2.4rem;
        }
        span:nth-of-type(6) {
          width: 3rem;
        }
        span:nth-of-type(7) {
          width: 1.8rem;
        }
        span:nth-of-type(8) {
          width: 0.4rem;
        }
      }
      .detailBox {
        height: calc(100% - 0.68rem);
        font-size: 0.18rem;
        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.6rem;
          border-bottom: 0.01rem solid #e5e5e5;
          span {
            text-align: center;
            color: #666666;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(1) {
            width: 0.6rem;
          }

          span:nth-of-type(2) {
            width: 1.6rem;
          }
          span:nth-of-type(3) {
            width: 0.8rem;
            display: flex;
            text-align: center;
            justify-content: center;
            > span {
              line-height: 0.24rem;
              border-radius: 0.12rem;
              font-size: 0.18rem;
              height: 0.24rem;
            }
          }
          span:nth-of-type(4) {
            width: 1rem;
          }
          span:nth-of-type(5) {
            width: 2.4rem;
          }
          span:nth-of-type(6) {
            width: 3rem;
          }
          span:nth-of-type(7) {
            width: 1.8rem;
          }

          span:nth-of-type(8) {
            width: 0.4rem;
            font-size: 0.22rem;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem !important;
    border: 0.01rem solid #e5e5e5 !important;
    background: #fff !important;
  }
}
</style>